module.exports = __webpack_public_path__ + "0fd5f4cf088624c1c7a831dea9063059.pdf";